import { UnstyledButton, UnstyledButtonLink } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import useStyles from './UserMenu.styles';
import type { MenuItem } from './types';

function UserNavLink({
  href,
  onClick,
  text,
  Icon,
  isActive,
  isCritical,
  count,
  dataTestId,
}: MenuItem) {
  const { cx, classes } = useStyles();
  const NavLinkComponent = href ? UnstyledButtonLink : UnstyledButton;

  return (
    <div className={cx(classes.userNavLinkContainer, { isActive })}>
      <NavLinkComponent
        href={href}
        className={cx(classes.userNavLink, { isCritical })}
        onClick={onClick}
        data-test-id={dataTestId || dt.common.components.appShellHeader.menuItem}
      >
        {Icon}
        <Text variant="subhead-medium">{text}</Text>
        {count ? <div className={classes.userNavLinkBadge}>
          <Text variant="headline-small" color="white">{count}</Text>
        </div> : null}
      </NavLinkComponent>
    </div>
  );
}

export default UserNavLink;
